// Port de app/camera-diaria.tsx.
import { Carregando } from "@/app/Carregando";
import { Redirect, useLocalSearchParams } from "@/navigation";
import { lazy } from "react";

const CameraDiariaScreen = lazy(() => import("@/screens/CameraDiaria"));

export default function CameraDiariaRoute() {
  const params = useLocalSearchParams<{ label?: string; postoId?: string }>();
  // WEB: sem os params do posto (F5/deep link) a diária não pode ser registrada daqui —
  // volta para a tela da diária, que refaz as validações (docs/port/04 §5.2).
  if (!params.label && !params.postoId) return <Redirect href="/registro-diaria" />;
  return (
    <Carregando cor="#000000">
      <CameraDiariaScreen />
    </Carregando>
  );
}
